<template>
  <div class="shade-chil">
    
    <i class="iconfont resource-icon">&#xe7c5;</i>
    <h1 class="resource-title">{{$t('message.标签列表')}}</h1>
    <div style="height: 578px border-bottom: 1px solid #ddd">
      <div class="resource">
        <div id="resourceList"
          class="resourceList" 
          v-loading="loadingFlag"
          :element-loading-text="$t('message.拼命加载中')"
          element-loading-spinner="el-icon-loading">
          <el-table
            v-show="getMulti"
            ref="multipleTable"
            :data="tagDatas"
            tooltip-effect="dark"
            style="width: 100%"
            height="558"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              label="No."
              type="index"
              width="55">
            </el-table-column>
            <el-table-column
              prop="id"
              :label="$t('message.标签ID')"
              width="200">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('message.标签名称')"
              >
            </el-table-column>
            <el-table-column
              prop="count"
              :label="$t('message.标签下的用户数')"
              width="200">
            </el-table-column>
          </el-table>
          <el-table
            v-show="!getMulti"
            ref="singleTable"
            :data="tagDatas"
            tooltip-effect="dark"
            style="width: 100%"
            height="558"
            highlight-current-row
            @current-change="handleCurrentChange">
            <el-table-column
              label="No."
              type="index"
              width="55">
            </el-table-column>
            <el-table-column
              prop="id"
              :label="$t('message.标签ID')"
              width="200">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('message.标签名称')"
              >
            </el-table-column>
            <el-table-column
              prop="count"
              :label="$t('message.标签下的用户数')"
              width="200">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="myObject">
      {{ tagDatas.length }} {{$t('message.个项目')}}
    </div>
    
    <div class="on-btn">
      <el-button type="" size="mini" @click="onLoad" icon="el-icon-refresh" round
        >{{$t('message.刷新')}}</el-button
      >
      <el-button type="" size="mini" @click="onButtonClick(0)" icon="el-icon-close" round
        >{{$t('message.关闭')}}</el-button
      >
      <el-button type="primary" size="mini" @click="onButtonClick(1)" icon="el-icon-check" round
        >{{$t('message.选择')}}</el-button
      >
    </div>
  </div>
</template>

<script>
import shade from "@/components/shade/shade";
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "wechatTagStore",
  props: {
    ismulti: {
      type: Boolean,
      default: true
    }
  },
  components: {
    shade,
  },
  data() {
    return {
      tagDatas: [],
      multipleSelection: [],
      currentRow: null,
      loadingFlag: false,
    };
  },
  methods: {
    onLoad() {
      rejecthttp(true,'get',"/manage/wechat/gettags",{
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
             if(doc.data.data.tags)
            this.tagDatas = doc.data.data.tags;
            }
            })
      // this.$http.get("/manage/wechat/gettags", {}).then((doc) => {
      //   if (doc.data.Code != "MSGKEY_OK") {
      //     this.$message({
      //       type: "error",
      //       message: doc.data.Message,
      //     });
      //   } else {
      //     if(doc.data.data.tags)
      //       this.tagDatas = doc.data.data.tags;
      //   }
      // });
    },
    onButtonClick(id) {
      if (id == 1) {
        if (this.ismulti == true) {
          this.$emit("onClick", { sel: this.multipleSelection });
          // this.multipleSelection.splice(0, this.multipleSelection.length);
        } else this.$emit("onClick", { reverseid: this.currentRow.name });
      } else {
        this.$emit("onClick", {});
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
  },
  computed: {
    getMulti() {
      return this.ismulti;
    }
  },
  created() {
    this.onLoad();
  },
  mounted() {},
};
</script>

<style scoped>
.myObject {
  position: absolute;
  left: 22px;
  bottom: 20px;
  color: #303133;
}

.on-btn {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.resource-title {
  position: absolute;
  top: 15px;
  left: 48px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #303133;
  font-weight: 600;
}

.resource-icon {
  position: relative;
  top: -7px;
  font-size: 27px;
  color: #303133;
  margin-bottom: 20px;
}

.resource-icon:after {
  position: absolute;
  content: "";
  display: block;
  height: 90%;
  width: 0;
  border-left: 3px solid #303133;
  left: -10px;
  top: 2px;
}

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.shade-chil {
  width: 1050px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.shade-chil .listBtn-box {
  position: absolute;
  width: 670px;
  height: 30px;
  line-height: 30px;
  /* border-right: 1px solid #ddd; */
  /* border-left   1px solid #ddd */
  padding-left: 10px;
  top: -37px;
  left: 3px;
  z-index: 1000;
}
.shade-chil .listBtn-box span a {
  color: #303133;
  font-size: 10px;
}

.shade-chil .listBtn-box span i {
  color: #303133;
  font-size: 10px;
}

.box {
  width: 600px;
  margin-left: 100px;
}
.box li {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 35px;
}
.box li .label {
  width: 80px;
  font-size: 14px;
  color: #444;
}

.resourceList {
  width: 100%;
  height: 560px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* align-content: center; */
  align-content: flex-start;
  /* position: relative; */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding-left: 20px;
}

.renameTextArea {
  position: relative;
  width: 80px;
  resize: none;
  overflow: visible;
  height: auto;
  background-color: #fff;
  z-index: 1001;
}

.renameTextAreaDialog {
  position: relative;
  width: 350px;
  height: 80px;
  resize: none;
  overflow: visible;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// src/components/wechat/wechatTagStore.vue